import { APP_PREFIX_PATH } from "../config/AppConfig";

export const roles = {
  admin: "admin",
  moderator: "moderator",
};

const dashBoardNavTree = {
  key: "home5",
  path: `${APP_PREFIX_PATH}/`,
  title: "Панель управления",
  icon: "SearchOutlined",
  breadcrumb: false,
  submenu: [
    {
      key: "home2",
      path: `${APP_PREFIX_PATH}/home`,
      title: "Панель управления",
      icon: "HomeOutlined",
      submenu: [],
      other: true,
    },
    {
      key: "application",
      path: `${APP_PREFIX_PATH}/application`,
      title: "Заявка",
      icon: "UnorderedListOutlined",
      submenu: [],
      other: true,
    },
    {
      key: "category",
      path: `${APP_PREFIX_PATH}/category`,
      title: "Категория",
      icon: "AppstoreOutlined",
      submenu: [],
      other: true,
    },
    {
      key: "product",
      path: `${APP_PREFIX_PATH}/product`,
      title: "Продукт",
      icon: "InboxOutlined",
      submenu: [],
      other: true,
    },
    {
      key: "customers",
      path: `${APP_PREFIX_PATH}/customer`,
      title: "Покупатели",
      icon: "UserOutlined",
      submenu: [],
      other: true,
    },
  ],
};

export const permissions = {
  READ_SEARCH_PANEL: "READ_SEARCH_PANEL",
};

export function generateNavigationConfig() {
  return dashBoardNavTree.submenu;
}

const navigationConfig = [dashBoardNavTree];

export default navigationConfig;
